module.exports = __webpack_public_path__ + "media/images/icons/map/marker-bus-77da21631e6d200797e5c9b211aeaffb.png";